import { DatePicker } from 'antd'
import withRepeater from './withRepeater'
{ RangePicker } = DatePicker

SequencedFormDateRangeInput = ({
  form
  formItem
  formItemPlaceholder
  defaultValue
  config
  save
  props...
}) ->

  getValues = ->
    dates = props.value
    if dates
      (save?.attributes || ['startDate', 'endDate'])
        .map((attr)-> dates[attr])
        .sort((a, b)-> a-b)

  <RangePicker
    { props... }
    format={config?.format or 'DD-MM-YYYY HH:mm'}
    showTime={config?.showTime or true}
    picker={config?.picker or 'date'}
    value={defaultValue or getValues()}
    onChange={(dates) ->
      datesObj = save?.attributes?.reduce((acc, value, index)->
        { acc..., [value]: dates[index] }
      , {}) or { startDate: dates[0], endDate: dates[1] }
      props.onChange(datesObj)
    }
    placeholder={formItemPlaceholder or save?.attributes.map((str) -> _.startCase(str))}
  />

export default withRepeater(SequencedFormDateRangeInput, { selector: (value) -> value })
